import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, MotionConfig, motion } from "motion/react";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import ScrollProgress from "./components/ScrollProgress";
import MobileBookBar from "./components/MobileBookBar";
import Home from "./pages/Home";
import Booking from "./pages/Booking";
import NotFound from "./pages/NotFound";
import { EASE } from "./motion";

function Page({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0, transition: { duration: 0.6, ease: EASE } }}
      exit={{ opacity: 0, y: -16, transition: { duration: 0.3, ease: "easeIn" } }}
    >
      {children}
    </motion.div>
  );
}

export default function App() {
  const location = useLocation();
  return (
    // reducedMotion="user" respects the visitor's "reduce motion" OS setting.
    <MotionConfig reducedMotion="user">
      <ScrollProgress />
      <Nav />
      <AnimatePresence mode="wait" onExitComplete={() => { if (!window.location.hash) window.scrollTo(0, 0); }}>
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Page><Home /></Page>} />
          <Route path="/booking" element={<Page><Booking /></Page>} />
          <Route path="*" element={<Page><NotFound /></Page>} />
        </Routes>
      </AnimatePresence>
      <Footer />
      {location.pathname !== "/booking" && <MobileBookBar />}
    </MotionConfig>
  );
}
